import React, {useState} from "react";
import {useDispatch} from "react-redux";
import {
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import ZeusButton from "../../../../components/Button/Button";
import Loader from "../../../../components/Loader";
import {addEditAquaticGroupProfile} from "../../../../redux/Actions/toolsTab.action";
import {TYPE_VALUES} from "./constants";

const AquaticProfileModal = (props) => {
  const {onClose, open, profile = {}} = props;
  const [data, setData] = useState({...profile});
  const dispatch = useDispatch();

  const onSubmit = () => {
    dispatch(addEditAquaticGroupProfile(data, onClose));
  };

  const handleChange = (e) => {
    setData((prevValue) => ({
      ...prevValue,
      [e.target.name]: extractNumbers(e.target.value || null),
    }));
  };

  return (
    <Modal unmountOnClose={true} isOpen={open} backdrop={"static"}>
      <Loader />
      <ModalHeader>{`Configure ${profile.group_name}`}</ModalHeader>
      <ModalBody>
        <Row>
          <FormInput
            data-cy="capacity-input"
            label="Capacity"
            name="capacity"
            onChange={handleChange}
            unit="gal"
            value={data.capacity}
          />
          <Col md={6}>
            <FormGroup>
              <label className="form-control-label roboto-bold" htmlFor="type">
                Type
              </label>
              <div className="ml-4">
                <Input
                  checked={data.type === TYPE_VALUES.indoor}
                  id={TYPE_VALUES.indoor}
                  onChange={() =>
                    setData((preValue) => ({...preValue, type: TYPE_VALUES.indoor}))
                  }
                  type="radio"
                  data-cy="indoor-input"
                />
                <label
                  className="form-control-label roboto-bold"
                  htmlFor={TYPE_VALUES.indoor}
                >
                  Indoor
                </label>
              </div>
              <div className="ml-4">
                <Input
                  checked={data.type === TYPE_VALUES.outdoor}
                  id={TYPE_VALUES.outdoor}
                  onChange={() =>
                    setData((preValue) => ({...preValue, type: TYPE_VALUES.outdoor}))
                  }
                  type="radio"
                  data-cy="outdoor-input"
                />
                <label
                  className="form-control-label roboto-bold"
                  htmlFor={TYPE_VALUES.outdoor}
                >
                  Outdoor
                </label>
              </div>
            </FormGroup>
          </Col>
          <FormInput
            data-cy="design-flow-rate-input"
            label="Design Flow Rate"
            name="design_flow_rate"
            onChange={handleChange}
            unit="GPM"
            value={data.design_flow_rate}
          />
          <FormInput
            data-cy="minimum-flow-rate-input"
            label="Minimum Flow Rate"
            name="minimum_flow_rate"
            onChange={handleChange}
            unit="GPM"
            value={data.minimum_flow_rate}
          />
          <FormInput
            data-cy="surface-area-input"
            label="Surface Area"
            name="surface_area"
            onChange={handleChange}
            value={data.surface_area}
            unit="sq ft"
          />
        </Row>
      </ModalBody>
      <ModalFooter>
        <ZeusButton onClick={onSubmit} data-cy={"submit-btn"}>
          Submit
        </ZeusButton>
        <ZeusButton onClick={onClose} data-cy={"cancel-btn"} type="secondary">
          Cancel
        </ZeusButton>
      </ModalFooter>
    </Modal>
  );
};

export default AquaticProfileModal;

function extractNumbers(input) {
  if (!input) return null;
  return input.replace(/[^0-9.]/g, "");
}

const FormInput = (props) => {
  const {label, unit, ...rest} = props;
  return (
    <Col md={6}>
      <FormGroup row>
        <Col md={12}>
          <label className="form-control-label roboto-bold">{label} Label</label>
        </Col>
        <Col md={12}>
          <InputGroup className="input-group-alternative">
            <Input {...rest} />
            <InputGroupText>{unit}</InputGroupText>
          </InputGroup>
        </Col>
      </FormGroup>
    </Col>
  );
};
